import {
  addReminder,
  REMINDER_TO_ME,
  REMINDER_TRIGGER,
  updateReminder,
} from '../../../../../../utils/missionReminders';
import { sameRecurPattern, scheduleRecurring } from '../../../../../../utils/recurringSchedule';

/** Next reminder list for Set/Update, or null when the draft isn't ready. */
export function buildReminderUpdate({
  reminders,
  pickerMode,
  recurDraft,
  editingId,
  draftDate,
  note,
  now = Date.now(),
}) {
  const savedNote = note.trim() || undefined;
  if (pickerMode === 'recurring') {
    if (!recurDraft) return null;
    const existing = editingId ? reminders.find((r) => r.id === editingId) : null;
    const fresh = scheduleRecurring(recurDraft, now);
    if (!fresh) return null;
    let at = fresh.at;
    let recur = fresh.recur;
    if (existing?.recur && sameRecurPattern(existing.recur, fresh.recur)) {
      const kept = {
        ...existing.recur,
        end: fresh.recur.end,
      };
      if (fresh.recur.end === 'times') kept.times = fresh.recur.times;
      else delete kept.times;
      if (fresh.recur.end === 'until') kept.until = fresh.recur.until;
      else delete kept.until;
      const usedUp = (kept.end === 'times' && (kept.fired || 0) >= kept.times)
        || (kept.end === 'until' && Date.parse(existing.at) > Date.parse(kept.until));
      if (!usedUp) {
        at = existing.at;
        recur = kept;
      }
    }
    const payload = {
      trigger: REMINDER_TRIGGER.AT_TIME,
      at,
      recur,
      to: REMINDER_TO_ME,
      note: savedNote,
    };
    return editingId
      ? updateReminder(reminders, editingId, payload)
      : addReminder(reminders, payload);
  }
  if (!draftDate) return null;
  if (editingId) {
    return updateReminder(reminders, editingId, {
      at: draftDate.toISOString(),
      note: savedNote,
      recur: null,
    });
  }
  return addReminder(reminders, {
    trigger: REMINDER_TRIGGER.AT_TIME,
    at: draftDate.toISOString(),
    to: REMINDER_TO_ME,
    note: savedNote,
  });
}
